export const navigationBarHeight = "64px";

export const authNavRoutePrefix = "/my";
